<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 10C9.77614 10 10 10.2239 10 10.5V16.5C10 19.5376 12.4624 22 15.5 22H21.5C21.7761 22 22 22.2239 22 22.5C22 22.7761 21.7761 23 21.5 23H15.5C11.9101 23 9 20.0899 9 16.5V10.5C9 10.2239 9.22386 10 9.5 10Z" fill="currentColor"/>
</svg>
